<template>
  <div>
    <HeadlineContainer headline="Search" :breadcrumbs="breadcrumbs"/>

    <div class="container">
      <form @submit.prevent="submit" style="margin-bottom: 22px">
        <div class="row">
          <div class="col-xs-20">
            <input v-model="term" type="text" class="form-control" placeholder="Enter search term...">
          </div>

          <div class="col-xs-4">
            <button type="submit" class="btn btn-black btn-block">
              <i class="fa fa-search"></i> Search
            </button>
          </div>
        </div>
      </form>

      <LoadingSpinner v-if="loading"/>

      <div v-else>
        <div v-for="result in search.attributes.results" class="panel panel-default panel-search-result">
          <div class="panel-body">
            <router-link :to="result.url">
              <h3>
                {{ result.name }}
              </h3>
            </router-link>

            <span class="label" :class="getLabelClass(result)">
              {{ getLabelText(result) }}
            </span>
          </div>
        </div>

        <div v-if="search.attributes.results.length === 0" class="text-center" style="padding: 20px 0">
          <i>
            There are no results to display. Try another query.
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import Load from '@/mixins/Load'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {HeadlineContainer, LoadingSpinner},

  mixins: [Load],

  data() {
    return {
      term: this.$route.query.term,
      search: null,

      loading: true
    }
  },

  watch: {
    '$route'() {
      this.term = this.$route.query.term

      this.load()
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    breadcrumbs() {
      return [
        {text: 'Search'}
      ]
    }
  },

  methods: {
    submit() {
      this.$router.push('/search?term=' + this.term)
    },

    load() {
      this.loading = true

      http.post('/api/v2/search', {query: this.term})
          .then(response => {
            this.search = response.data.data

            if (this.search.attributes.results.length === 1) {
              return this.$router.push(this.search.attributes.results[0].url)
            }

            this.loading = false
          })
    },

    getLabelClass(result) {
      if (result.type === 'companies') {
        return 'label-info'
      }

      if (result.type === 'people') {
        return 'label-success'
      }

      if (result.type === 'magazine-recipients') {
        return 'label-warning'
      }
    },

    getLabelText(result) {
      if (result.type === 'companies') {
        return 'Company'
      }

      if (result.type === 'people') {
        return 'Person'
      }

      if (result.type === 'magazine-recipients') {
        return 'Magazine Recipient'
      }
    }
  }
}
</script>

<style>
.panel-search-result h3 {
  margin: 0
}
</style>